import {createSelector} from "reselect";
import {IAppDispatch, IAppState} from "../../core/store/mainReducer";
import {TooltipsAction} from "../../modules/tooltips/tooltipsAction";

export const TooltipsState = createSelector((state: IAppState) => state.tooltipsReduser.text, (text) => ({text}));

export const TooltipsDispatch = (dispatch: IAppDispatch) => ({
    closeTooltips: () => dispatch(TooltipsAction.closeTooltips({}))
});
